import {ReadOnlyTextField} from "components/Shared/ReadOnlyTextField";
import React from "react";

export const ReadOnlyEmailFieldSet = ({value, previousValue, label,}) => {
    return new Array(Math.max(value.length, previousValue?.value?.length || 0))
        .fill(1)
        .map((_, index) => [value[index], previousValue?.value?.[index]])
        .map((emails, index) => (
            <ReadOnlyTextField
                key={index}
                label={label}
                value={emails[0]}
                previousValue={previousValue && {value: emails[1]}}
                additionalLabelText={index + 1}
            />)
        )
}